const MAX_RETRY_DELAY_MS = 120_000;

/**
 * Parses a Retry-After header value into milliseconds.
 *
 * Supports two formats per RFC 7231:
 *  - Integer seconds, e.g. "5"
 *  - HTTP-date, e.g. "Mon, 23 Feb 2026 12:00:00 GMT"
 *
 * Returns `null` when the header is missing or unparseable.
 * Clamps the result to MAX_RETRY_DELAY_MS to prevent indefinite waits.
 */
export function parseRetryAfterMs(headerValue: string | null): number | null {
  if (headerValue == null) return null;

  const trimmed = headerValue.trim();
  if (trimmed.length === 0) return null;

  const seconds = Number(trimmed);
  if (Number.isFinite(seconds) && seconds >= 0) {
    return clamp(seconds * 1000);
  }

  const date = Date.parse(trimmed);
  if (!Number.isNaN(date)) {
    const delayMs = date - Date.now();
    if (delayMs <= 0) return 0;
    return clamp(delayMs);
  }

  return null;
}

function clamp(ms: number): number {
  return Math.min(ms, MAX_RETRY_DELAY_MS);
}
